import { ApiResponseObject } from "../../types";
import { axios } from "../../utils/axios";
import {
  ISastavPakovanjaIstorija,
  ITtIstorijaKodaPayload,
  ITtKodDetalji,
  IzvestajiOPrometu,
  IzvestajiOPrometuPayload,
  MonitoringDetailsResponse,
  MonitoringListFilterPayload,
  MonitoringListResponse,
  Tracking,
  TrackingListFilterPayload,
  TrackingListFiltersData,
  TrackingListResponse,
} from "./trackAndTrace.types";

const postTtIstorijaKoda = (
  payload: ITtIstorijaKodaPayload
): Promise<ApiResponseObject<Tracking[]>> => {
  return axios.post("/ttIstorijaKoda", payload);
};

const postTtIstorijaKodaSastav = (
  payload: ISastavPakovanjaIstorija
): Promise<ApiResponseObject<Tracking[]>> => {
  return axios.post("/ttIstorijaKodaSastav", payload);
};

const postTtDetaljiIstorije = (
  id: number,
  tipPakovanjaId: number
): Promise<ApiResponseObject<ITtKodDetalji>> => {
  return axios.post("/ttKodDetalji", { id, tipPakovanjaId });
};

const getInicijalnaTabelaZaPracenje = (
  payload: Partial<TrackingListFilterPayload> | undefined
): Promise<ApiResponseObject<TrackingListResponse>> => {
  return axios.post("/inicijalnaTabelaZaPracenje", payload ?? {});
};

const getTrackingListFiltersData = (): Promise<
  ApiResponseObject<TrackingListFiltersData>
> => {
  return axios.get("/inicijalniPodaciZaPracenje");
};

const postTtPracenjeKodaSastav = (
  payload: ISastavPakovanjaIstorija
): Promise<ApiResponseObject<Tracking[]>> => {
  return axios.post("/ttPracenjeKodaSastav", payload);
};

const getMonitoringList = (
  payload: Partial<MonitoringListFilterPayload> | undefined
): Promise<ApiResponseObject<MonitoringListResponse>> => {
  return axios.post("/monitoring-list", payload);
};

const getMonitoringDetails = ({
  id,
}: {
  id: number | null;
}): Promise<ApiResponseObject<MonitoringDetailsResponse>> => {
  return axios.get("/monitoring-details", { params: { id } });
};

const getIzvestajiOPrometu = (
  payload: IzvestajiOPrometuPayload | undefined
): Promise<ApiResponseObject<IzvestajiOPrometu>> => {
  return axios.post("/mfin/izvestaji-o-prometu", payload);
};

export const trackAndTraceRepo = {
  postTtIstorijaKoda,
  postTtIstorijaKodaSastav,
  postTtDetaljiIstorije,
  getInicijalnaTabelaZaPracenje,
  getInicijalniPodaciZaPracenje: getTrackingListFiltersData,
  postTtPracenjeKodaSastav,
  getMonitoringList,
  getMonitoringDetails,
  getIzvestajiOPrometu,
};
